function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-allgaier-logo"
}, "allgaier");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-allgaier-logo"
}, "allgaier logo");

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "116.31 0 151.34 0 151.34 97.09 174.11 97.09 174.11 127.56 116.31 127.56 116.31 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "186.16 0 221.19 0 221.19 97.09 243.92 97.09 243.92 127.56 186.16 127.56 186.16 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "303.81 79.8 303.81 49.95 353.03 49.95 353.03 107.38 332.69 127.56 277.33 127.56 255.88 107.38 255.88 20.03 277.47 0 338.11 0 338.11 29.13 291.27 29.13 291.27 96.56 317.22 96.56 317.22 79.8 303.81 79.8"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 487.8,
  width: 36.14,
  height: 127.56
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "543.95 0 613.13 0 613.13 28.7 579.98 28.7 579.98 49.13 613.13 49.13 613.13 79.11 579.98 79.11 579.98 97.58 613.13 97.58 613.13 127.56 543.81 127.56 543.95 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.63,138.19h-22.8V102.93h22.8ZM149.75,73H98.9l-21.57,20V200.6h34.72v-31H136.4v31h34.85V93.07Z",
  transform: "translate(-77.33 -73.03)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M506.83,138.19H484V102.93h22.79ZM520.94,73H470.15l-21.63,20V200.6h34.75v-31h24.31v31h34.88V93.07Z",
  transform: "translate(-77.33 -73.03)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M762.61,134.07H741.85V102.49h20.76Zm36.94-41-21.5-20H706.1V200.6h35.51V167.35h21.88V200.6h36.06V160.78L788,149.28l11.53-11Z",
  transform: "translate(-77.33 -73.03)"
});

var SvgAllgaier = function SvgAllgaier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-allgaier-logo desc-allgaier-logo",
    viewBox: "0 0 722.22 127.56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-allgaier-logo"
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAllgaier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/allgaier.1ebec085.svg";
export { ForwardRef as ReactComponent };